import { CommonModule, Location } from '@angular/common';
import { Component, NgModule, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule, Routes } from '@angular/router';
import { DxButtonModule, DxCheckBoxModule, DxDateBoxModule, DxFormComponent, DxFormModule, DxSelectBoxModule, DxTagBoxModule, DxTextBoxModule, DxTooltipModule } from 'devextreme-angular';
import dxDateBox from 'devextreme/ui/date_box';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subscription, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CoreModule } from 'src/app/core/core.module';
import { CommonPreLoadedService } from 'src/app/core/services/common/common-pre-loaded.service';
import { AppInfoService } from '../../services';
import { APIConfing } from '../../services/apiconfing.service';
import { BaseRequestService } from '../../services/base-request.service';
import { CommonService } from '../../services/common.service';
import { ESSAccountVerifyModule } from '../essaccount-verify/essaccount-verify.component';
import { ESSNewPasswordModule } from '../essnew-password/essnew-password.component';
import { ForgotPasswordVerifyModule } from '../forgot-password/forgot-password.component';
import { EncryptDecryptService } from '../../services/encrypt-decrypt.service';

@Component({
  selector: 'app-register-form',
  templateUrl: './register-form.component.html',
  styleUrls: ['./register-form.component.scss'],
  standalone: false
})
export class RegisterFormComponent implements OnInit {
  @ViewChild('regForm', { static: false }) regInstance: DxFormComponent;
  emailIDpattern: any;
  Mobilepattern: any;
  isBGImageEnabled = false;
  isShowImgLogo = false;

  regSubmitSpinner = 'RegisterPage';
  getImgLogo: any;
  isSubLogo: Subscription;

  cityList = [];
  states: any = [];
  locList: any = [];
  cityMaster: any = [];

  getLocationList: any = {
    languageType: 0,
    userID: 9999,
    searchKey: ''
  };

  SpinnerModal: any = {
    bdColor: '',
    fullScreen: false,
    size: '',
    color: '',
    type: ''
  };
  essContinue: any = {
    text: 'Register',
    useSubmitBehavior: true,
    width: '100%',
    type: 'success'
  };
  genArr: any = [
    { ID: 0, gen: 'NA' },
    { ID: 1, gen: 'Male' },
    { ID: 2, gen: 'Female' },
    { ID: 3, gen: 'Transgender' }
  ];

  registerModel: any = {
    "rid": 0,
    "cid": 1,
    "ContractID": 0,
    "salutation": 0,
    "firstName": null,
    "middleName": null,
    "lastName": null,
    "eMailID": null,
    "officialEMailID": null,
    "mobileNo": null,
    "phoneNo": null,
    "gender": 1,
    "dob": null,
    "passportNo": null,
    "passportExpDate": null,
    "panNo": null,
    "nameAsPerPAN": null,
    "aadharNo": null,
    "nameAsPerAadhar": null,
    "localityID": 0,
    "stateID": null,
    "cityID": 0
  };


  constructor(public appInfo: AppInfoService, private baseRequset: BaseRequestService, private route: ActivatedRoute,
    public common: CommonService, private cookies: CookieService, private spinner: NgxSpinnerService,
    private _location: Location, private enc: EncryptDecryptService,
    private router: Router, private commonAPI: CommonPreLoadedService,
    private toastrService: ToastrService) {
    this.SpinnerModal.bdColor = APIConfing.data.spinnerProp.bdColor;
    this.SpinnerModal.fullScreen = APIConfing.data.spinnerProp.fullScreen;
    this.SpinnerModal.size = APIConfing.data.spinnerProp.size;
    this.SpinnerModal.type = APIConfing.data.spinnerProp.type;
    this.SpinnerModal.color = APIConfing.data.spinnerProp.color;
    this.isBGImageEnabled = APIConfing.data.isBGImageEnabled;
    this.emailIDpattern = this.common.emailIDPattren;
    this.Mobilepattern = this.common.Mobilepattern;
    this.onSelectChangeState = this.onSelectChangeState.bind(this);
    this.fnSelectCity = this.fnSelectCity.bind(this);
    this.fnOnValueChangedDate = this.fnOnValueChangedDate.bind(this);
    this.onSelectChangeGender = this.onSelectChangeGender.bind(this);
    this.route.queryParams
      .subscribe(params => {
        if (params && params.cid) {
          this.registerModel.cid = atob(params.cid);
          if (this.registerModel.cid > 0) {
            this.commonAPI.fnGetCustomerLogoURL(this.registerModel.cid, 1);
          } else {
            this.isShowImgLogo = false;
          }
        }
      });
    this.isSubLogo = this.commonAPI.getCustomerLogo$().pipe(catchError(err => throwError(err)))
      .subscribe(obj => {
        if (obj && obj.length > 0) {
          this.getImgLogo = obj[0].logoURL;
          this.isShowImgLogo = true;
          this.commonAPI.sendTitle(obj[0].customerTitle);
          this.commonAPI.customerLogo.next(null);
        } else if (obj && obj.length === 0) {
          this.isShowImgLogo = false;
          this.getImgLogo = null;
        }
      });
  }

  ngOnInit() {
    this.fnGetStates();
    this.fnLocationList(this.getLocationList);
  }
  fnGetStates() {
    this.baseRequset.fnpost('/CSS/Client/CountryStateList', { cid: 1, MasterRID: 1 })
      .subscribe((dataRESP: any) => {
        if (dataRESP && dataRESP.code === this.baseRequset.status.success) {
          this.states = dataRESP.dataObject;
        } else if (dataRESP.code === 'E002') {
          this.toastrService.error(APIConfing.data.E002);
        } else if (dataRESP.code === 'E001') {
          this.toastrService.error(dataRESP.message, 'Error');
          this.states = [];
        } else if (dataRESP.code === this.baseRequset.warning.code) {
          this.toastrService.warning(dataRESP.message, 'Details');
          this.states = [];
        } else {
          this.states = [];
        }
      }, error => {
        this.toastrService.error(APIConfing.data.E002, 'Error');
        this.spinner.show();
      });
  }
  fnLocationList(obj2) {
    // const obj = { cid: this.userInfo.cid, SmasterRID: obj2.countryID, MasterRID: obj2.stateID, languageType: this.userInfo.languageType };
    this.baseRequset.fnpost('/CSS/Client/GetLocationListOnSearch', obj2)
      .subscribe((dataRESP: any) => {
        if (dataRESP && dataRESP.code === this.baseRequset.status.success) {
          this.cityMaster = dataRESP.dataObject;
        } else if (dataRESP.code === 'E002') {
          this.toastrService.error(APIConfing.data.E002);
        } else if (dataRESP.code === 'E001') {
          this.toastrService.error(dataRESP.message, 'Error');
          this.cityList = [];
        } else if (dataRESP.code === this.baseRequset.warning.code) {
          this.toastrService.warning(dataRESP.message, 'Details');
          this.cityList = [];
        } else {
          this.cityList = [];
        }
      },
        error => {
          if (error && error.error && error.error.message) {
            this.toastrService.error(APIConfing.data.E002, 'Error');
          }
          else {
            this.toastrService.error(APIConfing.data.E002, 'Error');
          }
        });
  }
  onSelectChangeState(e) {
    const newValue = e;
    this.registerModel.cityID = 0;
    this.registerModel.localityID = 0;
    this.cityList = [];
    this.locList = [];
    this.cityList = this.cityMaster.filter((item) => item.stateID === e.value);
  }
  fnSelectCity(id) {
    if (id) {
      const obj = { cityID: id.value };
      this.locList = [];
      this.registerModel.localityID = 0;
      // const obj = { cid: this.userInfo.cid, SmasterRID: obj2.countryID, MasterRID: obj2.stateID, languageType: this.userInfo.languageType };
      this.baseRequset.fnpost('/CSS/Consultant/GetESSMasterLocLocality', obj)
        .subscribe((dataRESP: any) => {
          if (dataRESP && dataRESP.code === this.baseRequset.status.success) {
            this.locList = dataRESP.dataObject;
          } else if (dataRESP.code === 'E002') {
            this.toastrService.error(APIConfing.data.E002);
          } else if (dataRESP.code === 'E001') {
            this.toastrService.error(dataRESP.message, 'Error');
            this.locList = [];
          } else if (dataRESP.code === this.baseRequset.warning.code) {
            this.toastrService.warning(dataRESP.message, 'Details');
            this.locList = [];
          } else {
            this.locList = [];
          }
        },
          error => {
            if (error && error.error && error.error.message) {
              this.toastrService.error(APIConfing.data.E002, 'Error');
            }
            else {
              this.toastrService.error(APIConfing.data.E002, 'Error');
            }
          });
    }
  }
  fnOnValueChangedDate(e) {
    if (e.value) {
      this.registerModel.dob = e.value;
    }
  }
  onSelectChangeGender(e: any) {
    if (e.value) {
      this.registerModel.gender = e.value;
    }
  }
  fnRegisterEmail() {
    const valid = this.regInstance.instance.validate();
    if (valid) {
      this.spinner.show(this.regSubmitSpinner);
      this.baseRequset.fnpost('/CSS/Consultant/SaveConsPersonalDtsFromPublic', this.registerModel)
        .subscribe((dataRESP: any) => {
          if (dataRESP && dataRESP.code === this.baseRequset.status.success) {
            this.toastrService.success(dataRESP.message, 'success');
            sessionStorage.setItem(this.enc.encryptUsingAES256('ESS_token'), dataRESP.dataObject.token);
            sessionStorage.setItem(this.enc.encryptUsingAES256('ESS_Refresh_token'), dataRESP.data.refreshToken);
            localStorage.setItem(this.enc.encryptUsingAES256('ESS_token'), dataRESP.dataObject.token);
            // this.ESSToken = getRespData.dataObject.token;
            // this.fnGetSessionDS();
            this.spinner.hide(this.regSubmitSpinner);
            this._location.back();
          } else if (dataRESP.code === 'E002') {
            this.toastrService.error(APIConfing.data.E002);
            this.spinner.hide(this.regSubmitSpinner);
          } else if (dataRESP.code === 'E001') {
            this.toastrService.error(dataRESP.message, 'Error');
            this.spinner.hide(this.regSubmitSpinner);
          } else if (dataRESP.code === this.baseRequset.warning.code) {
            this.toastrService.warning(dataRESP.message, 'Details');
            this.spinner.hide(this.regSubmitSpinner);
          } else {
            this.spinner.hide(this.regSubmitSpinner);
          }
        }, error => {
          this.toastrService.error(APIConfing.data.E002, 'Error');
          this.spinner.hide(this.regSubmitSpinner);
        });
    }
    else {
      this.toastrService.error('All Mandatory fields are required!!!', 'Error');
    }
  }
  fnBack() {
    this._location.back();
  }
}



const regRoutes: Routes = [
  { path: 'register', component: RegisterFormComponent },
];
@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(regRoutes),
    // DxButtonModule,
    // DxCheckBoxModule,
    // DxTextBoxModule,
    FormsModule,
    DxFormModule,
    // DxSelectBoxModule,
    // DxTagBoxModule,
    // DxDateBoxModule,
    // DxTooltipModule,
    NgxSpinnerModule,
    CoreModule,
    // ForgotPasswordVerifyModule,
    // ESSAccountVerifyModule,
    // ESSNewPasswordModule
  ],
  declarations: [RegisterFormComponent],
  exports: [RegisterFormComponent]
})
export class RegisterFormModule { }